import * as React from "react"

import { StaticImage } from "gatsby-plugin-image";

import * as S from './styles';

export default function Mentioned() {
  return (
    <S.Container>
      <S.Content>
        <h1>We've been mentioned in:</h1>
        <S.Images>
          <StaticImage
            src={`../../images/social-google.png`}
            alt="Google"
            placeholder="blurred"
            layout="fixed"
            width={207}
            height={70}
            quality="40"
          />
          <StaticImage
            src={`../../images/social-yahoo.png`}
            alt="Yahoo"
            placeholder="blurred"
            layout="fixed"
            width={252}
            height={70}
            quality="40"
          />
          <StaticImage
            src={`../../images/social-tiktok.png`}
            alt="Tik Tok"
            placeholder="blurred"
            layout="fixed"
            width={240}
            height={70}
            quality="40"
          />
          <StaticImage
            src={`../../images/social-youtube.png`}
            alt="Youtube"
            placeholder="blurred"
            layout="fixed"
            width={167}
            height={70}
            quality="40"
          />
        </S.Images>
      </S.Content>
    </S.Container>
  )
}